import EduMaterialModel from './EduMaterialModel';
import QuestionModel from './QuestionModel';
export default class QuizDetailsResponse {
    constructor(supportedLocales) {
        this.id = null;
        this.difficultyLevel = null;
        this.type = null;
        this.eduDuration = 15;
        this.quizDuration = 15;
        this.iconTemporaryFileUrl = '';
        this.quizIcon = null;
        this.activeFrom = null;
        this.availabilityInStatistics = null;
        this.activeTo = null;
        this.status = null;
        this.translations = [];
        this.quizType = undefined;
        this.publicResults = false;
        this.winnerPoints = null;
        this.publishedToCompanies = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                subject: '',
                description: '<span></span>',
                quizIntroduction: '<span></span>',
                questions: [],
                eduMaterials: [],
            };
        });
        this.supportedLocales = supportedLocales;
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.type = from.type;
            to.difficultyLevel = from.difficultyLevel;
            to.eduDuration = from.eduDuration;
            to.quizDuration = from.quizDuration;
            to.iconTemporaryFileUrl = from.iconTemporaryFileUrl;
            to.availabilityInStatistics = from.availabilityInStatistics;
            to.relatedToAction = from.relatedToAction;
            to.quizIcon = from.quizIcon;
            to.activeFrom = new Date(from.activeFrom);
            to.activeTo = new Date(from.activeTo);
            to.status = from.status;
            to.translations = [];
            to.publicResults = from.publicResults;
            to.winnerPoints = from.winnerPoints;
            to.publishedToCompanies = from.publishedToCompanies || [];
            //get base untranslated question
            let questionsToEachTranslation = [];
            let eduMaterialsToEachTranslation = [];
            let newArray = Object.entries(from?.translations);
            let map = new Map(newArray);
            // eslint-disable-next-line no-unused-vars
            for (let [key, t] of map.entries()) {
                if (t.questions && t.questions.length > 0) {
                    const copiedQuestions = JSON.parse(JSON.stringify(t.questions));
                    questionsToEachTranslation = copiedQuestions.map((q) => {
                        q.question = '';
                        q.answerOptions = q.answerOptions.map((ao) => {
                            ao.text = '';
                            return ao;
                        });
                        return q;
                    });
                }
                if (t.eduMaterials && t.eduMaterials.length > 0) {
                    const copiedMaterials = JSON.parse(JSON.stringify(t.eduMaterials));
                    eduMaterialsToEachTranslation = copiedMaterials.map((m) => {
                        m.text = '<span></span>';
                        return m;
                    });
                }
            }

            to.supportedLocales.forEach((element) => {
                to.translations[element] = {
                    title: from.translations[element]?.title,
                    description: from.translations[element]?.description ? from.translations[element]?.description : '<span></span>',
                    subject: from.translations[element]?.subject,
                    quizIntroduction: from.translations[element]?.quizIntroduction,
                    questions: QuestionModel.copy(
                        from.translations[element]?.questions?.length > 0
                            ? from.translations[element]?.questions
                            : questionsToEachTranslation,
                        to.translations[element]?.questions
                    ),
                    eduMaterials: EduMaterialModel.copy(
                        from.translations[element]?.eduMaterials?.length > 0
                            ? from.translations[element]?.eduMaterials
                            : eduMaterialsToEachTranslation,
                        to.translations[element]?.eduMaterials
                    ),
                };
            });
            to.quizType = from.quizType;
        } else {
            to = new QuizDetailsResponse();
        }
    }

    static copy(from, supportedLocales) {
        const to = new QuizDetailsResponse(supportedLocales);
        QuizDetailsResponse.assign(from, to);
        return to;
    }
}
